/*@ngInject*/
const FormSummaryRepository = function (baseRepository, sortUtil, coreMediator) {

    angular.extend(this, baseRepository);

    this.getExportUrl = function (submissionId, formId, formSummaryGridName) {
        return coreMediator.getSingleUseToken().then((token) => {
            return `/formDownload/${_.lowerCase(formSummaryGridName)}.csv?submissionId=${submissionId}&formId=${formId}` +
                   `&formSummaryGridName=${encodeURIComponent(formSummaryGridName)}&t=${encodeURIComponent(token)}`;
        });
    };

    this.importForms = function (submissionId, formId, importType, formTemplateName, file) {
        let config,
            formData,
            url;

        return coreMediator.getSingleUseToken().then((token) => {
            url = `/formUpload/FormUploadServlet?uploadType=${importType}&submissionId=${submissionId}&formId=${formId}`
                + `&fileName=${file.name}&size=${file.size}&formTemplateName=${encodeURIComponent(formTemplateName)}&t=${encodeURIComponent(token)}`;

            formData = new FormData();

            config = {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            };

            formData.append('Filedata', file);

            return this.post(url, formData, config);
        });

    };
};

angular.module('umFormViewer')
    .service('formSummaryRepository', FormSummaryRepository);
